import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'

const settings = window.GM_STATE

const formatMoney = function (cents, format) {
  const nFormat = format || settings.shopify.moneyFormat

  const formattedMoney = shopifyFormatMoney(cents, nFormat)

  if (formattedMoney.indexOf('.00') > -1) {
    return formattedMoney.replace('.00', '')
  }

  return formattedMoney
}

const getCustomBadgeClass = (tagName) => {
  let tagClass = ''

  if (['new'].includes(tagName)) {
    tagClass = 'badge'
  }

  return tagClass
}

const shouldFilterSaleBadge = (item, badgeText) => {
  return isSale(item) && badgeText?.toLowerCase().includes('on sale')
}

const getBadges = (item, badge, variants) => {
  // Return a Sold Out badge if variants are unavailable
  if (!isAvailable(variants)) {
    return [{
      text: translate.product.soldOut,
      customClass: '',
      backgroundColor: '',
      textColor: ''
    }]
  }

  // Initialize badges array with a Sale badge if applicable
  const currentBadges = isSale(item)
    ? [{
        text: computeDiscountPercentage(item) + '% ' + translate.product.off,
        customClass: '',
        backgroundColor: '',
        textColor: ''
      }]
    : []

  // Check if badge contains "on sale" or "On Sale" - if so, don't add it when product is on sale
  if (badge && !shouldFilterSaleBadge(item, badge)) {
    currentBadges.unshift({
      text: badge,
      customClass: '',
      backgroundColor: '',
      textColor: ''
    })
  } else if (item.metafields?.product_badges && !shouldFilterSaleBadge(item, item.metafields.product_badges)) {
    currentBadges.unshift({
      text: item.metafields.product_badges,
      customClass: '',
      backgroundColor: '',
      textColor: ''
    })
  }

  return currentBadges
}

const getPriceSubscription = (planGroups, price) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let priceSubscription = price

  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      priceSubscription = priceSubscription - priceSubscription * priceAdjustment.value / 100
    } else {
      priceSubscription = priceSubscription - priceAdjustment.value
    }
  }

  return priceSubscription
}

const getSubscriptionSave = (planGroups) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let subscriptionSave = null

  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      subscriptionSave = `${priceAdjustment.value}%`
    } else {
      subscriptionSave = `${formatMoney(priceAdjustment.value)}`
    }
  }

  return subscriptionSave && `Subscribe & Save ${subscriptionSave}`
}

const formatAsPercentage = (number) => {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(number / 100)
}

const addBadgeSale = (badges, price, originalPrice) => {
  if (price && originalPrice && price < originalPrice) {
    const salePercent = Math.round((originalPrice - price) / originalPrice * 100)
    const text = `${formatAsPercentage(salePercent)} off`

    badges.unshift({
      text,
      tag: 'label-sale',
      customClass: 'badge-card-sale',
      backgroundColor: '',
      textColor: ''
    })
  }

  return badges
}

const formatRangePrice = (values, format) => values && values.map(item => formatMoney(item * 100, format)).join(' - ')

const getDefaultImage = (img) => {
  return (Array.isArray(img) && img.length === 0) || !img ? GM_STATE.shopify.defaultImage : img
}

const getGraphQLID = (id, type) => `gid://shopify/${type}/${id}`

const getGraphQLIds = (ids, type) => {
  if (ids.length === 0) return []

  return ids.map((id) => getGraphQLID(id, type))
}

function convertPrice (price) {
  return typeof price === 'string' ? parseFloat(price) : price
}

function getPrice (price) {
  return price ? convertPrice(price) * 100 : 0
}

function isSale (item) {
  return item?.compare_at_price && item?.compare_at_price !== 0 && item?.compare_at_price > item?.price
}

function isSoldOut (item) {
  return !item.available
}

function isAvailable (variants) {
  return variants?.find(variant => variant.available)
}

function computeDiscountPercentage(item) {
  if (!item || !item.compare_at_price || !item.price) return 0

  const compareAtPrice = convertPrice(item.compare_at_price)
  const price = convertPrice(item.price)

  if (compareAtPrice === 0 || price === 0) return 0

  return Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
}

export {
  formatMoney,
  getBadges,
  getCustomBadgeClass,
  getPriceSubscription,
  getSubscriptionSave,
  addBadgeSale,
  formatRangePrice,
  getDefaultImage,
  getGraphQLIds,
  getGraphQLID,
  getPrice,
  isSale,
  isSoldOut,
  isAvailable,
  computeDiscountPercentage
}
